/**
 * Alias pencarian jurusan.
 * Key  : kata yang mungkin diketik user (Indonesia / singkatan / umum)
 * Value: array kata kunci bahasa Inggris yang ada di nama prodi.
 *
 * Tambah / kurangi entry sesuai kebutuhan tanpa mengubah logika lain.
 */
export const searchAliases = {
  // ── Bisnis & Manajemen ─────────────────────────────────────────────────
  'bisnis':              ['business', 'management', 'commerce', 'commercial'],
  'usaha':               ['business', 'management'],
  'manajemen':           ['management', 'business'],
  'pemasaran':           ['marketing'],
  'sdm':                 ['human resource', 'human resources', 'hr management'],
  'sumber daya manusia': ['human resource', 'human resources'],

  // ── Akuntansi & Keuangan ───────────────────────────────────────────────
  'akuntansi':  ['accounting', 'accountancy'],
  'akuntan':    ['accounting', 'accountancy'],
  'keuangan':   ['finance', 'financial', 'accounting'],
  'pajak':      ['taxation', 'tax'],
  'perbankan':  ['banking', 'finance'],
  'ekonomi':    ['economics', 'economic', 'business', 'finance'],

  // ── Teknologi & Komputer ───────────────────────────────────────────────
  'komputer':    ['computer', 'computing', 'informatics', 'information technology'],
  'informatika': ['informatics', 'computer', 'computing', 'information technology'],
  'it':          ['information technology', 'computer', 'informatics', 'computing'],
  'ti':          ['information technology', 'computer', 'informatics'],
  'sistem':      ['information system', 'system', 'computing'],
  'data':        ['data science', 'data', 'analytics', 'information'],
  'ai':          ['artificial intelligence', 'machine learning', 'data science'],
  'kecerdasan':  ['artificial intelligence', 'intelligent'],
  'jaringan':    ['network', 'networking', 'communication'],
  'siber':       ['cyber', 'security', 'cybersecurity'],
  'cyber':       ['cyber', 'security', 'cybersecurity'],

  // ── Teknik ─────────────────────────────────────────────────────────────
  'teknik':      ['engineering', 'technology', 'technical'],
  'sipil':       ['civil', 'construction'],
  'elektro':     ['electrical', 'electronics', 'electronic'],
  'elektronika': ['electronics', 'electronic', 'electrical'],
  'mesin':       ['mechanical', 'machine', 'machinery'],
  'industri':    ['industrial', 'industry'],
  'kimia':       ['chemical', 'chemistry'],
  'lingkungan':  ['environmental', 'environment', 'ecology'],
  'biomedis':    ['biomedical', 'biomedics', 'medical'],
  'material':    ['material', 'materials'],
  'fisika':      ['physics', 'physical'],

  // ── Arsitektur & Desain ────────────────────────────────────────────────
  'arsitektur':  ['architecture', 'architectural'],
  'desain':      ['design', 'visual', 'graphic', 'creative'],
  'visual':      ['visual', 'design', 'graphic'],
  'grafis':      ['graphic', 'visual design', 'design'],
  'interior':    ['interior', 'architecture'],
  'fashion':     ['fashion', 'textile'],
  'tekstil':     ['textile', 'fashion'],
  'seni':        ['art', 'fine art', 'creative', 'visual'],
  'animasi':     ['animation', 'animated'],
  'game':        ['game', 'gaming', 'interactive media'],
  'film':        ['film', 'cinema', 'movie'],
  'fotografi':   ['photography', 'photographic'],
  'musik':       ['music', 'musical'],
  'teater':      ['theater', 'theatre', 'drama', 'performing arts'],

  // ── Kesehatan & Medis ──────────────────────────────────────────────────
  'kedokteran':  ['medicine', 'medical', 'doctor'],
  'dokter':      ['medicine', 'medical', 'doctor'],
  'medis':       ['medical', 'medicine'],
  'farmasi':     ['pharmacy', 'pharmaceutical'],
  'apoteker':    ['pharmacy', 'pharmaceutical'],
  'keperawatan': ['nursing', 'nurse'],
  'perawat':     ['nursing', 'nurse'],
  'gizi':        ['nutrition', 'nutritional', 'dietetics'],
  'nutrisi':     ['nutrition', 'nutritional'],
  'kesehatan':   ['health', 'public health', 'medical'],
  'kebidanan':   ['midwifery', 'midwife'],
  'fisioterapi': ['physiotherapy', 'physical therapy'],
  'radiologi':   ['radiology', 'radiological'],
  'optometri':   ['optometry', 'optometrist'],
  'gigi':        ['dental', 'dentistry'],
  'dental':      ['dental', 'dentistry'],

  // ── Pendidikan ─────────────────────────────────────────────────────────
  'pendidikan':  ['education', 'teaching', 'pedagogy'],
  'guru':        ['education', 'teaching'],
  'pgsd':        ['primary education', 'elementary'],
  'paud':        ['early childhood', 'preschool'],

  // ── Hukum & Sosial ─────────────────────────────────────────────────────
  'hukum':       ['law', 'legal', 'jurisprudence'],
  'notaris':     ['notary', 'law'],
  'sosial':      ['social', 'sociology', 'society'],
  'sosiologi':   ['sociology', 'social'],
  'politik':     ['political', 'politics', 'policy'],
  'hubungan internasional': ['international relation', 'international relations', 'diplomacy'],
  'hubungan':    ['international relation', 'relation', 'diplomacy'],
  'administrasi': ['administration', 'administrative', 'public administration'],

  // ── Komunikasi & Media ─────────────────────────────────────────────────
  'komunikasi':  ['communication', 'communications', 'media'],
  'jurnalistik': ['journalism', 'journalist', 'media'],
  'media':       ['media', 'communication', 'broadcasting'],
  'penyiaran':   ['broadcasting', 'media'],
  'broadcasting':['broadcasting', 'media', 'television'],
  'periklanan':  ['advertising', 'marketing communication'],
  'humas':       ['public relation', 'public relations'],

  // ── Bahasa & Sastra ────────────────────────────────────────────────────
  'sastra':      ['literature', 'linguistics', 'language'],
  'bahasa':      ['language', 'linguistics', 'literature'],
  'inggris':     ['english', 'british'],
  'jepang':      ['japanese', 'japan'],
  'mandarin':    ['chinese', 'mandarin', 'china'],
  'korea':       ['korean', 'korea'],
  'arab':        ['arabic', 'arab'],
  'linguistik':  ['linguistics', 'language', 'linguistic'],

  // ── Pariwisata & Perhotelan ────────────────────────────────────────────
  'pariwisata':  ['tourism', 'hospitality', 'travel'],
  'perhotelan':  ['hospitality', 'hotel management', 'hotel'],
  'hotel':       ['hospitality', 'hotel management', 'hotel'],
  'wisata':      ['tourism', 'travel'],
  'kuliner':     ['culinary', 'food', 'gastronomy'],
  'gastronomi':  ['gastronomy', 'culinary'],

  // ── Pertanian & Lingkungan ─────────────────────────────────────────────
  'pertanian':   ['agriculture', 'agricultural', 'agribusiness'],
  'agro':        ['agriculture', 'agro', 'agribusiness'],
  'kehutanan':   ['forestry', 'forest'],
  'perikanan':   ['fisheries', 'marine', 'aquaculture'],
  'laut':        ['marine', 'maritime', 'ocean'],
  'kelautan':    ['marine', 'maritime', 'oceanography'],
  'biologi':     ['biology', 'biological', 'life science'],
  'bioteknologi': ['biotechnology', 'biotech', 'biological technology'],

  // ── Psikologi & Konseling ──────────────────────────────────────────────
  'psikologi':   ['psychology', 'psychological'],
  'psikolog':    ['psychology', 'psychological'],
  'konseling':   ['counseling', 'guidance', 'psychology'],

  // ── Matematika & Aktuaria ──────────────────────────────────────────────
  'aktuaria':    ['actuarial', 'actuarial science'],
  'statistik':   ['statistics', 'statistical', 'actuarial'],
  'matematika':  ['mathematics', 'mathematical', 'math'],

  // ── Lain-lain ──────────────────────────────────────────────────────────
  'olahraga':    ['sport', 'sports', 'physical education'],
  'logistik':    ['logistics', 'supply chain'],
  'supply chain': ['supply chain', 'logistics'],
  'asuransi':    ['insurance', 'actuarial'],
  'properti':    ['property', 'real estate'],
};

/**
 * Mengembalikan array kata kunci pencarian yang diperluas berdasarkan alias.
 * Query asli selalu disertakan sebagai salah satu term.
 *
 * @param {string} query - input user (sudah lowercase & trim)
 * @returns {string[]} - array of search terms (lowercase)
 */
export function expandSearchTerms(query) {
  const q = query.toLowerCase().trim();
  const terms = new Set([q]);

  for (const [alias, expansions] of Object.entries(searchAliases)) {
    if (q.includes(alias) || alias.includes(q)) {
      expansions.forEach(e => terms.add(e.toLowerCase()));
    }
  }

  return [...terms];
}
